import { render, staticRenderFns } from "./DepOrthopedics.vue?vue&type=template&id=23412a1f&scoped=true&"
import script from "./DepOrthopedics.vue?vue&type=script&lang=js&"
export * from "./DepOrthopedics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23412a1f",
  null
  
)

export default component.exports